import { useTheme } from "@mui/material";
import photo from "../../assets/imgs/persons/informationMale.png";

export default function InformationMale({
	mainFill,
	primaryCircleFill,
	secondaryCircleFill,
	title,
	highlight,
	subtitle,
}) {
	const theme = useTheme();

	return (
		<div style={{ width: "100%", maxWidth: "700px", margin: "0 auto" }}>
			<svg
				viewBox="0 0 629 509"
				xmlns="http://www.w3.org/2000/svg"
				style={{ width: "100%", height: "auto", display: "block" }}
			>
				{/* BACKGROUND SHAPE */}
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M351.971 0.0162436C392.949 -1.03951 411.737 49.6557 447.505 68.2742C486.774 88.7145 541.172 81.9266 570.42 113.725C601.547 147.567 599.294 196.282 605.817 240.393C614.719 300.591 646.966 365.489 615.529 418.764C583.791 472.549 513.326 512.455 447.455 508.763C381.138 505.047 344.548 436.687 290.664 400.558C257.125 378.071 225.622 356.849 190.535 336.503C136.924 305.415 60.7635 300.856 30.1324 249.481C-1.60051 196.258 -18.4477 109.39 32.0171 70.6323C91.7612 24.7486 184.38 89.7519 259.78 73.1107C299.889 64.2583 310.762 1.07792 351.971 0.0162436Z"
					fill={mainFill}
				/>

				{/* CÍRCULOS */}
				<g filter="url(#filter0_d_998_3302)">
					<circle cx="450" cy="349" r="100" fill={primaryCircleFill} />
				</g>
				<g filter="url(#filter1_d_998_3302)">
					<circle cx="550" cy="185" r="10" fill={secondaryCircleFill} />
				</g>
				<g filter="url(#filter2_d_998_3302)">
					<circle cx="530" cy="303" r="30" fill={secondaryCircleFill} />
				</g>
				<g filter="url(#filter3_d_998_3302)">
					<circle cx="570" cy="253" r="20" fill={primaryCircleFill} />
				</g>

				{/* IMAGEM */}
				<rect
					x="233"
					y="204"
					width="368"
					height="245"
					fill="url(#pattern0_998_3302)"
				/>

				{/* TEXTO DENTRO DO SVG */}
				<text
					x="100"
					y="150"
					fill={theme.palette.white.main}
					fontWeight="500"
					fontSize="24"
				>
					{title}
				</text>
				<text
					x="100"
					y="180"
					fill={theme.palette.primary.main}
					fontWeight="600"
					fontSize="24"
				>
					{highlight}
				</text>
				<text
					x="100"
					y="210"
					fill={theme.palette.white.main}
					fontWeight="400"
					fontSize="16"
				>
					{subtitle?.split("\n").map((line, i) => (
						<tspan key={i} x="100" dy={i === 0 ? 0 : 18}>
							{line}
						</tspan>
					))}
				</text>

				{/* DEFINES */}
				<defs>
					<pattern
						id="pattern0_998_3302"
						patternContentUnits="objectBoundingBox"
						width="1"
						height="1"
					>
						<use
							xlinkHref="#image0_998_3302"
							transform="matrix(0.000651042 0 0 0.000977891 0 -0.000680298)"
						/>
					</pattern>
					<image
						id="image0_998_3302"
						width="1536"
						height="1024"
						preserveAspectRatio="none"
						href={photo}
					/>
				</defs>
			</svg>
		</div>
	);
}
